export const calculatePoints = (
  correctSolutions,
  result,
  getDetails = false
) => {
  if (!result || result.trim() === '') {
    // Ako je result prazan, vrati samo bonus poene
    let bonus = 18;
    const classLevel = parseInt(correctSolutions.grade);
    if (classLevel === 1 || classLevel === 2) {
      bonus = 12;
    } else if (classLevel === 3 || classLevel === 4) {
      bonus = 15;
    }

    return getDetails
      ? { totalPoints: bonus, detailedResults: [] }
      : { totalPoints: bonus };
  }
  let totalPoints = 0;
  const resultArray = result.split(':').filter(Boolean); // Učenikovi odgovori
  const solutionArray = correctSolutions.solutions.split(':').filter(Boolean); // Tačni odgovori
  const detailedResults = [];

  const getTaskPortionPoints = (index, totalTasks) => {
    const firstThird = Math.ceil(totalTasks / 3);
    const secondThird = Math.ceil((totalTasks * 2) / 3);
    if (index < firstThird) return 3;
    if (index < secondThird) return 4;
    return 5;
  };

  solutionArray.forEach((correctSolution, index) => {
    const matchQuestionNumber = correctSolution.match(/^\d+/);
    if (!matchQuestionNumber) return;
    const questionNumber = matchQuestionNumber[0];
    const correctAnswer = correctSolution.replace(/^\d+/, '').trim();
    const studentAnswers = resultArray.filter((answer) => {
      const studentQuestionNumber = answer.match(/^\d+/);
      return (
        studentQuestionNumber && studentQuestionNumber[0] === questionNumber
      );
    });

    let points = 0;
    const totalTasks = solutionArray.length;
    const portionPoints = getTaskPortionPoints(index, totalTasks);

    if (correctAnswer === 'X') {
      points = portionPoints; 
    } else if (studentAnswers.length === 0) {
      points = 0;
    } else if (studentAnswers.length > 1) {
      points = -(portionPoints / 4);
    } else {
      const studentAnswer = studentAnswers[0].replace(/^\d+/, '').trim();
      if (studentAnswer === correctAnswer) {
        points = portionPoints;
      } else {
        points = -(portionPoints / 4);
      }
    }

    totalPoints += points;

    // Skladištenje detalja samo ako je getDetails true
    if (getDetails) {
      detailedResults.push({
        questionNumber,
        correctAnswer,
        studentAnswers: studentAnswers.map((answer) =>
          answer.replace(/^\d+/, '').trim()
        ),
        points
      });
    }
  });

  let bonus = 18;
  const classLevel = parseInt(correctSolutions.grade);
  if (classLevel === 1 || classLevel === 2) {
    bonus = 12;
  } else if (classLevel === 3 || classLevel === 4) {
    bonus = 15;
  }
  totalPoints += bonus;
  totalPoints = Math.max(totalPoints, 0);

  let maxTotalPoints = 90;
  if (classLevel === 1 || classLevel === 2) {
    maxTotalPoints = 60;
  } else if (classLevel === 3 || classLevel === 4) {
    maxTotalPoints = 75;
  }
  totalPoints = Math.min(totalPoints, maxTotalPoints);

  // Vraćamo detalje samo ako je getDetails true
  return getDetails ? { totalPoints, detailedResults } : { totalPoints };
};
